<template>
    <v-container
      class="wrapper-ticket-message pa-0"
      :class="{ '' : isTicketSelected }"
    >
      <MessageList
        :messages="messages"
        :isTicketSelected="isTicketSelected"
        :selectedTicket="selectedTicket"
        @fileAttach="fileAttachHandler"
        @submit="submitMessage"
        :isCreateNewTicket="isCreateNewTicket"
        @closeTicket="closeTicket"
        @onSelectedDepartment="selectedDepartmentHandler"
        :toggleSelectionTicket="toggleSelectionTicket"
        :isMessageSend="isMessageSend"
        :loading="loading"
      />
    </v-container>
</template>

<script>
import MessageList from '@/views/dashboard/pages/ticket/partial/message/MessageList.vue'

export default {
  props: {
    isTicketSelected: Boolean,
    selectedTicket: Object,
    isCreateNewTicket: Boolean,
    toggleSelectionTicket: Boolean
  },
  data () {
    return {
      currentPage: 1,
      messages: [],
      ticketId: null,
      newTicket: null,
      files: null,
      selectedDepartmentId: null,
      isMessageSend: false,
      loading: false,
      intervalId: null
    }
  },
  components: {
    MessageList
  },
  methods: {
    fetchTicketMessages () {
      // const existingIds = new Set(this.meessages.map(msg => msg.id))
      var app = this
      app.$axios.get(this.$endpoint + 'ticketMessage', {
        params: {
          page: this.currentPage,
          options: JSON.stringify({ page: this.currentPage, itemsPerPage: 100 }),
          search: null,
          ticket_id: this.ticketId
        }
      })
        .then(r => {
          this.isMessageSend = !this.isMessageSend
          // const newMessages = r.data.data.filter(msg => !existingIds.has(msg.id))
          this.messages = r.data.data.reverse()
        })
        .catch(e => {
          console.error('Error:', e)
        })
    },
    fileAttachHandler (value) {
      this.files = value
    },
    submitTicket (data) {
      var app = this
      app.$axios.post(this.$endpoint + 'ticketing', {
        department_id: this.selectedDepartmentId,
        title: data.ticketTitle != null ? data.ticketTitle : 'new ticket',
        content: data.value.body ? data.value.body : ''
      })
        .then(r => {
          this.newTicket = r.data.data
          this.$emit('addTickets', this.newTicket)
          this.ticketId = r.data.data.id
          this.submitMessage(data)
        })
        .catch(e => {
          console.error('Error:', e)
        })
    },
    submitMessage (data) {
      // data: {value: {action , type , body} , ticketTitle , userIdentity}
      if (this.ticketId != null) {
        var app = this
        app.$axios.post(this.$endpoint + 'ticketMessage', {
          ticket_id: this.ticketId,
          message: data.value.body ? data.value.body : 'no caption'
        })
          .then(r => {
            // 1. sending sipmle (text)
            if (data.value.type == 'text') {
              this.fetchTicketMessages()
            }
            // 2. sending (file + text)
            if (data.value.type == 'text/file') {
              const formData = new FormData()
              formData.append('select', 'fileUpload')
              formData.append('type', 'ticket')
              formData.append('refId', r.data.data.id)
              this.files.forEach((file, index) => {
                formData.append(`file[${index}]`, file)
              })

              var app = this
              app.$axios.post(this.$endpoint + 'createdetail', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
                .then(r => {
                  this.fetchTicketMessages()
                })
                .catch(e => {
                  console.error('Error uploading file:', e)
                })
            }
          })
          .catch(e => {
            console.error('Error:', e)
          })
      } else {
        this.submitTicket(data)
      }
    },
    fetchMessagesSpTicket () {
      // const existingIds = new Set(this.meessages.map(msg => msg.id))
      this.loading = true
      var app = this
      app.$axios.get(this.$endpoint + 'ticketMessage', {
        params: {
          page: this.currentPage,
          options: JSON.stringify({ page: this.currentPage, itemsPerPage: 100 }),
          search: null,
          ticket_id: this.ticketId
        }
      })
        .then(r => {
          this.loading = false
          // const newMessages = r.data.data.filter(msg => !existingIds.has(msg.id))
          this.messages = r.data.data.reverse()
        })
        .catch(e => {
          console.error('Error:', e)
        })
    },
    selectedDepartmentHandler (val) {
      this.selectedDepartmentId = val
    },
    closeTicket (value) {
      this.$emit('closeTicket', value)
    }
  },
  mounted () {
    this.intervalId = setInterval(() => {
      this.fetchTicketMessages()
    }, 20000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  watch: {
    selectedTicket (val) {
      this.ticketId = val.id
      this.fetchMessagesSpTicket()
    },
    isCreateNewTicket (val) {
      this.ticketId = null
      this.messages = []
    }
  }
}
</script>
